import { Dialog, DialogContent } from "@/components/ui/dialog";

interface Props {
  open: boolean;
  onClose: () => void;
  testTitle?: string;          // "Test Técnico"
  exerciseTitle: string;       // "Sliding Window Rate Limiter"
  descriptionHtml: string;
}

export function InstructionsModal({
  open,
  onClose,
  testTitle = "Test Técnico",
  exerciseTitle,
  descriptionHtml,
}: Props) {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-auto p-10">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold tracking-tight">{testTitle}</h1>
          <p className="text-xl text-muted-foreground mt-2">{exerciseTitle}</p>
        </div>

        <div
          className="prose-test text-sm text-foreground/90"
          dangerouslySetInnerHTML={{
            __html: descriptionHtml || "<p>Sin instrucciones cargadas.</p>",
          }}
        />
      </DialogContent>
    </Dialog>
  );
}
